import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';
import {
  Result,
  TableWorker,
  // ResultInput,
  Competitor,
} from 'packages/common-types/schema-types';
import {useState, ChangeEvent, useEffect} from 'react';
import {retrieveMemberNames} from 'packages/common-utils/helpers';
import useAppSelector from 'packages/hooks/use-app-selector';
import {
  selectGeneratedRound,
  // selectLoadedRound,
  selectRoundMetadata,
  setGeneratedRound,
} from 'redux/features/round-slice';
import TextField from '@material-ui/core/TextField';
import {Typography} from '@material-ui/core';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import {UPDATE_LAST_ROUND} from 'packages/graphql/v2/mutations';
import {useMutation, useQuery} from '@apollo/client';
import {triggerToast} from 'redux/features/app-slice';
import {SUCCESS_UPDATE_ROUND} from 'packages/constants/constants';
import {GET_ROUND, GET_STANDING} from 'packages/graphql/v2/queries';
import Swal from 'sweetalert2';

type Props = DialogProps & {
  table?: Result;
  workerResult?: TableWorker;
  selectedRound: number;
  tournamentId: string;
};

type UpdateRoundVars = {
  tournamentId: string;
  result: {
    numberOfRound: number;
    indexs: number[];
    resultModify: {
      tableNumber: number;
      competitorOne: {
        name: string;
        result: number;
      };
      competitorTwo: {
        name: string;
        result: number;
      };
    };
  };
};

type GetStandingsVars = {
  tournamentId: string;
};
type GetStandingsData = {
  getStanding: {
    tournamentId: string;
    table: Competitor[];
  };
};

const ModifyRoundData = (props: Props) => {
  const {modalOpen, toggle, table, workerResult, selectedRound, tournamentId} =
    props;
  const dispatch = useAppDispatch();
  console.log(table);
  const tableNumber =
    (table && table.tableNumber) || (workerResult && workerResult.tableNumber);

  const savedCompetitorOne = table && table.competitorOne;
  const savedCompetitorTwo = table && table.competitorTwo;

  const generatedCompetitorOne = workerResult && workerResult.competitorOne;
  const generatedCompetitorTwo = workerResult && workerResult.competitorTwo;

  // const {competitorOne, competitorTwo, tableNumber} = table || {};

  const [resultA, setResultA] = useState(0);
  const [resultB, setResultB] = useState(0);

  // const loadedRound = useAppSelector(selectLoadedRound);
  const generatedRound = useAppSelector(selectGeneratedRound);
  const {currentRound} = useAppSelector(selectRoundMetadata);
  const playerANames =
    savedCompetitorOne?.name || retrieveMemberNames(generatedCompetitorOne);
  const playerBNames =
    savedCompetitorTwo?.name || retrieveMemberNames(generatedCompetitorTwo);

  const [updateRound] = useMutation<boolean, UpdateRoundVars>(
    UPDATE_LAST_ROUND
  );
  const {data: stadings} = useQuery<GetStandingsData, GetStandingsVars>(
    GET_STANDING,
    {
      variables: {
        tournamentId,
      },
      fetchPolicy: 'network-only',
    }
  );

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === 'score_1') setResultA(+event.target.value);
    if (event.target.name === 'score_2') setResultB(+event.target.value);
  };

  useEffect(() => {
    if (table) {
      setResultA(table.competitorOne.result);
      setResultB(table.competitorTwo.result);
    } else if (workerResult) {
      setResultA(workerResult.result.competitorOne);
      setResultB(workerResult.result.competitorTwo);
    }
  }, [table, workerResult]);

  const handleSaveOrEdit = async () => {
    if (resultA < 0 || resultB < 0) {
      toggle();
      Swal.fire({
        title: 'Error',
        text: 'La puntuación no puede ser negativa',
        icon: 'error',
      });
      return;
    }

    if (generatedRound && selectedRound === -1) {
      // ==> Save
      const {index, tables} = generatedRound;
      const currentTable = tables[tableNumber];

      const tablesCopy = [...tables];
      const tableToUpdate = {...currentTable};

      const newTable: TableWorker = {
        ...tableToUpdate,
        result: {
          competitorOne: resultA,
          competitorTwo: resultB,
        },
      };

      tablesCopy[tableNumber] = newTable;

      dispatch(setGeneratedRound({index, tables: tablesCopy}));
      toggle();
    } else {
      try {
        const indexs = [
          ...stadings?.getStanding.table
            .filter(({members}) =>
              members.find(({fullName}) => {
                const aux =
                  table.competitorOne.name.includes(fullName) ||
                  table.competitorTwo.name.includes(fullName);
                return aux;
              })
            )
            .map(({groupNumber}) => groupNumber),
        ];
        await updateRound({
          variables: {
            tournamentId,
            result: {
              numberOfRound: selectedRound,
              indexs,
              resultModify: {
                tableNumber: table.tableNumber,
                competitorOne: {
                  name: table.competitorOne.name,
                  result: resultA,
                },
                competitorTwo: {
                  name: table.competitorTwo.name,
                  result: resultB,
                },
              },
            },
          },
          refetchQueries: [
            {
              query: GET_ROUND,
              variables: {
                tournamentId,
                roundNumber: selectedRound,
              },
            },
          ],
        });
        dispatch(triggerToast(SUCCESS_UPDATE_ROUND));
        toggle();
      } catch (error) {
        console.error('ERROR ==> ', error);
      }
    }
  };

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="simple-dialog">
      <DialogTitle id="simple-dialog">Editar ronda</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Editando los campos para la mesa: {table?.tableNumber} en la ronda:{' '}
          {currentRound}
        </DialogContentText>
        <Typography variant="subtitle1">{playerANames}</Typography>
        {/* Agregar validaciones de que solo acepte numeros */}
        <TextField
          autoFocus
          value={resultA}
          variant="outlined"
          margin="dense"
          onChange={handleChange}
          name="score_1"
          label="Puntuación jugador A"
          type="text"
          fullWidth
        />
        <Typography style={{marginTop: 16}} variant="subtitle1">
          {playerBNames}
        </Typography>
        {/* Agregar validaciones de que solo acepte numeros */}
        <TextField
          value={resultB}
          variant="outlined"
          margin="dense"
          name="score_2"
          onChange={handleChange}
          label="Puntuación jugador B"
          type="text"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancelar
        </Button>
        <Button onClick={handleSaveOrEdit} color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModifyRoundData.defaultProps = {
  table: null,
  workerResult: null,
};

export default ModifyRoundData;
